var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('DatePicker', {
    staticClass: "date-picker",
    attrs: {
      "placeholder": _vm.label,
      "clearable": false,
      "format": "DD.MM.YYYY",
      "disabled-date": _vm.disabledDates
    },
    on: {
      "change": _vm.updateDate
    },
    model: {
      value: _vm.localDate,
      callback: function callback($$v) {
        _vm.localDate = $$v;
      },
      expression: "localDate"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }